import { message } from 'antd';
import { takeLatest, put } from 'redux-saga/effects';
import { logger } from 'services';
import { updateDocumentTemplateContentAction } from '../../actions';
import { updateDocumentTemplateContent } from '../../slices';
import { saveDocumentTemplate } from '../_save-template';
function* updateDocumentTemplateContentSaga(action) {
    const { payload: { sectionId, content, templateId, handleAlways, handleFailure, handleSuccess } } = action;
    try {
        yield put(updateDocumentTemplateContent({
            templateId,
            sectionId,
            content
        }));
        const documentTemplate = yield saveDocumentTemplate(templateId);
        if (handleSuccess) {
            handleSuccess(documentTemplate);
        }
    } catch (error) {
        logger.error('an error updating content in the document', {
            error
        });
        message.error('There was an error updating content in the document');
        if (handleFailure) {
            handleFailure();
        }
    }
    if (handleAlways) {
        handleAlways();
    }
}
export function* watchUpdateDocumentTemplateContentSaga() {
    yield takeLatest(updateDocumentTemplateContentAction.type, updateDocumentTemplateContentSaga);
}
